export enum IconColorList {
  collections,
  termLevel,
}
